// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import Base64 from 'js-base64'
import VueCookies from 'vue-cookies'

import App from './App'
import router from './router'
import global_ from './components/Global'
import request from './utils/request.js'

import 'element-ui/lib/theme-chalk/index.css'
import './static/css/style.css'

/* 图片预览 */
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import moment from 'moment';

/* 地图 */
import BaiduMap from 'vue-baidu-map'

/** 公共类 **/
import "./library/api.js";

import antiShakeTool from "./library/antiShakeTool.js";

Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(VueCookies)
Vue.use(preview)
Vue.use(BaiduMap, {ak:'MVVS7FziaFdv6V4Od7XVX6hR'});
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD');
  }
});

Vue.http.options.emulateJSON = true;
Vue.config.productionTip = false;
Vue.prototype.GLOBAL = global_
Vue.prototype.$axios = request

Vue.directive("debounce-loading", {
  bind(el, binding, vnode) {   
    const [func, time = 3500] = binding.value;
    el.debounceFn = antiShakeTool.debounce(func, time, el);
    el.addEventListener("click", el.debounceFn);
  },
   componentUpdated(el, binding) {    
    const [func, time = 3500] = binding.value;
    el.removeEventListener('click', el.debounceFn)
    el.debounceFn = antiShakeTool.debounce(func, time, el);
    el.addEventListener('click', el.debounceFn)
  },
  unbind(el) {
    el.removeEventListener('click', el.debounceFn)
  },
});

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js